//recentordertable.jsx
import React, { useState, useEffect } from "react";
import "../../css/Recentordertable.css";
import { useCartInventoryContext } from "../../../Context/Cache/CartInventoryContext";
import { LoadingScreen } from "../../LoadingScreen";
import { useRecentOrdersContext } from "../../../Context/Cache/RecentOrder/RecentOrdersContext";
import EmptyOrderPage from "./EmptyOrderPage";
import { toast } from "react-toastify";
import { Link, useLocation } from "react-router-dom"; // Amit
const RecentOrderTable = () => {
  const {
    loading,
    toggleAccordion,
    handleSearch,
    filteredOrders,
    searchTerm,
    activeIndex,
    filterProductsfn,
    orders
  } = useRecentOrdersContext();
  console.log("Fetched Order", filteredOrders, 18)
 
  const { selectedRows, setSelectedRows, currentPath, setCurrentPath, addToCart, handleStoreInCache } = useCartInventoryContext()
  const [recentOrder, setRecentOrder] = useState([]);
  console.log("filteredOrders", filteredOrders)
  //  useEffect(()=>{
 
  //   const newFilteredOrders = filteredOrders
  //   .map(order => ({
  //     ...order,
  //     filteredProducts: filterProductsfn(order.products)
  //   }))
  //   .filter(order => order.filteredProducts.length > 0);
 
  // },[filteredOrders])
 
  // Effect to filter combined data whenever the search term changes or orders are updated
  useEffect(() => {
    // Filter and map orders to include only those with matching filteredProducts
    const newFilteredOrders = orders
      .map((order) => {
        const filteredProducts = filterProductsfn(order.combinedDetails, searchTerm);
        return {
          ...order,
          filteredProducts, // Assign filtered products to the order
        };
      })
      .filter(order => order.filteredProducts.length > 0); // Only include orders with matching products
 
    // Set the filtered orders to the state
    setRecentOrder(newFilteredOrders);
  }, [orders, searchTerm]);
 
 
  let previousError = null;
  const decimalPattern = /^(\d*\.{0,1}\d{0,2}$)/;
  const handleInputChange = (index, productIndex, field, value) => {
    setRecentOrder((prevRecords) => {
      // Create a copy of the previous records to update
      const updatedRecords = [...prevRecords];
 
      // Copy the specific order and its products
      const order = { ...updatedRecords[index] };
      const filteredProducts = [...order.filteredProducts];
      const product = { ...filteredProducts[productIndex] };
 
      // Validate and update the product based on the field and value
      if (field === "requestedQuantity") {
        if (value !== "" && (isNaN(value) || value < 0)) {
          product[field] = 0;
          const errorMessage = "Requested Quantity must be a positive number";
          toast.error(errorMessage);
        } else if (value > parseInt(product.strava_availablequantity, 10)) {
          product[field] = 0;
          const errorMessage = "Requested Quantity cannot be more than Available Quantity";
          toast.error(errorMessage);
        } else {
          product[field] = value !== "" ? parseInt(value, 10) : "";
        }
      } else if (field === "counterOffer") {
        const decimalPattern = /^\d*\.?\d*$/; // Adjust this pattern based on requirements
        if (value !== "" && (isNaN(value) || !value.match(decimalPattern))) {
          product[field] = 0;
          const errorMessage = "Counter Offer must be a valid number";
          toast.error(errorMessage);
        } else {
          product[field] = formatCurrency(value);
        }
      } else {
        // Handle other fields if necessary
        if (value !== "" && (isNaN(value) || value <= 0)) {
          product[field] = 0;
          const errorMessage = "Value must be a positive number";
          toast.error(errorMessage);
        } else {
          product[field] = parseInt(value, 10);
        }
      }
 
      // Update the product in the filtered products array
      filteredProducts[productIndex] = product;
      // Update the filtered products in the order
      order.filteredProducts = filteredProducts;
      // Update the order in the orders array
      updatedRecords[index] = order;
 
      return updatedRecords;
    });
  };
 
 
  const formatCurrency = (value) => {
    // Remove any non-numeric characters except the decimal point
    value = value.replace(/[^\d.]/g, "");
 
    // Ensure two decimal places
    const parts = value.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add commas to the integer part
 
    // Limit to two decimal places
    if (parts[1] && parts[1].length > 2) {
      parts[1] = parts[1].slice(0, 2);
    }
 
    // Join integer and decimal parts
    value = parts.join(".");
 
    // Add dollar sign
    return `${value}`;
  };
 
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(date);
  };
 
  function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
 
  // Funtion to formatCurrency
  function formatNumber(number) {
    if (isNaN(number) || number === null || number === undefined) {
      number = 0;
    }
    const formattedNumber = Number(number).toFixed(2);
    return formatNumberWithCommas(formattedNumber);
  }
 
  // Amit
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  useEffect(() => {
    if (pathnames != currentPath) {
      setSelectedRows([]);
      setCurrentPath(pathnames);
    }
  }, [])
 
  console.log("Recent Orders", recentOrder)
 
  return (
    <div className="page-main-wrapper flex justify-center">
      {loading && <LoadingScreen />}
      <div className="w-full nycfix-mb-resp-product">
        <div className="">
          <div className="flex items-center justify-between">
            <span className="lineheight18 font-bold font-weight-bold">
              Recent Orders
            </span>
            <span className="float-right">
              <input
                type="text"
                className="search-bar2"
                placeholder="Search Product"
                value={searchTerm}
                onChange={handleSearch}
              />
            </span>
          </div>
          {recentOrder.length === 0 ? (
            <EmptyOrderPage />
          ) : (
            <div className="col-lg-12 nycfix-recent-orders">
 
              {/* product view wrapper area start */}
              <div className="accordion2">
                {recentOrder.length === 0 ? (
                  <div>No orders found.</div>
                ) : (                  
                  recentOrder.map((order, index) => (
                    <div key={index} className="accordion2-item bg-white">
                      <div
                        className="accordion2-header "
                        onClick={() => toggleAccordion(index)}
                      >
                        <span className="accordion2-icon">
                          {activeIndex === index ? "-" : "+"}
                        </span>
                        <div className="w-full flex justify-between items-center">
                          <p className="accordion2-title">
                            ORDER ID: {order.order.ordernumber}
                          </p>
                          <div className="flex flex-col">
                            <span className="flex">
                              <p>Order Date:</p>
                              <p>{formatDate(order.order.createdon)}</p>
                            </span>
                            <span className="flex font-bold gap-1">
                              <p>Grand Total :</p>
                              {console.log("Type of Data",typeof(order.order.totalamount))}
                              <p>$ {parseFloat(order.order.totalamount).toFixed(2)}</p>
                            </span>
                          </div>
                        </div>
                      </div>
 
                      {/* new code */}
                      {activeIndex === index && (
                        <div className="accordion2-content">
                          <div className="order-details">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>SKU&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                                  <th>Image</th>
                                  <th>Product Name</th>
                                  <th>Brand</th>
                                  <th>Color</th>
                                  <th>Size(with UOM)</th>
                                  {/* <th>Available Quantity</th> */}
                                  <th>Requested Quantity</th>
                                  <th>Price</th>
                                  <th>Offer Price</th>
                                  <th style={{ width: "12%" }}></th>
                                </tr>
                              </thead>
                              <tbody>
                                {console.log("UOM Data", order)}
                                {order.filteredProducts.map((item, itemIndex) => (
                                  <tr
                                    key={itemIndex}
                                    className={itemIndex % 2 === 0 ? "bg-white" : "bg-pink-900"}
                                  >
                                    <td>{item.productnumber}</td>
                                    <td>
                                      <img
                                        // src={item.entityimage_url || "default-image-url.png"} // Provide a default image if none is available
                                        src={`https://nycdatastorage.blob.core.windows.net/compressproduct-uatcontain/${item.productnumber}.jpg`}
                                        alt="Product"
                                        width="50"
                                        height="50"
                                      />
                                    </td>
                                    <td>{item.productname}</td>
                                    <td>{item.nyc_brand}</td>
                                    <td>{item.nyc_color ? item.nyc_color : "N/A"}</td>
                                    <td>{item.size}{" "}{item.nyc_sizeuom}</td>
                                    {/* <td>{item.strava_availablequantity}</td> */}
                                    <td>{item.quantity}</td>
                                    {/* <td>
                                      <input
                                        type="text"
                                        value={item.requestedQuantity || item.quantity}
                                        className="width50"
                                        onChange={(e) =>
                                          handleInputChange(index, itemIndex, "requestedQuantity", e.target.value)
                                        }
                                      />
                                      </td> */}
                                    <td>
                                      {item.price != null ? `$ ${formatNumber(parseFloat(item.price).toFixed(2))}` : "-"}
                                    </td>
                                    <td>{parseFloat(item.priceperunit).toFixed(2)}
                                      {/* <input
                                        type="number"
                                        step="0.01"
                                        min={0}
                                        value={item.counterOffer}
                                        className="border-1 pl-1"
                                        style={{ width: "76px" }}
                                        onChange={(e) =>
                                          handleInputChange(index, itemIndex, "counterOffer", e.target.value)
                                        }
                                      /> */}
                                    </td>
                                    <td>
                                    {item.isMatchingProductFound ? (
                                        <button
                                          className="add-to-cart"
                                          onClick={() =>
                                            addToCart({
                                              ...item,
                                              requestedQuantity: item.requestedQuantity,
                                              counterOffer: item.counterOffer,
                                            })
                                          }
                                        >
                                          Add to Cart
                                        </button>
                                      ) : (
                                        <p className="font-light" style={{fontSize: '0.6rem'}}>
                                          Currently, this product is not available
                                        </p>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
 
                            </table>
                          </div>
                        </div>
                      )}
                    </div>
                  )) 
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
 
export default RecentOrderTable;